import { render, staticRenderFns } from "./ModalEditarDadosContatoPssc.vue?vue&type=template&id=d44c000c&lang=pug"
import script from "./ModalEditarDadosContatoPssc.vue?vue&type=script&lang=js"
export * from "./ModalEditarDadosContatoPssc.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarDadosContatoPssc.vue?vue&type=style&index=0&id=d44c000c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports